var _defs, _g, _path, _g2, _g3, _path2, _g4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g5, _g6, _path17, _path18, _path19, _path20, _path21, _g7, _path22, _g8, _path23, _g9, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g0, _g1, _g10, _g11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2StandingPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130,
    height: 150,
    viewBox: "280 0 114 119",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7e6b25796f_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2 7.769531 L 101 7.769531 L 101 106 L 2 106 Z M 2 7.769531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "59557b5dae_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6 63 L 100 63 L 100 116.585938 L 6 116.585938 Z M 6 63 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2c99078a3b_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.894531 55 L 101.765625 55 L 101.765625 116.585938 L 1.894531 116.585938 Z M 1.894531 55 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9ee8a7f53e_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20 7.769531 L 83 7.769531 L 83 75 L 20 75 Z M 20 7.769531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e57eb24b4c_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23 79 L 33 79 L 33 116.585938 L 23 116.585938 Z M 23 79 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0a32614c7d_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15 71 L 41 71 L 41 116.585938 L 15 116.585938 Z M 15 71 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "04e445921d_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 288 49 L 387 49 L 387 118.214844 L 288 118.214844 Z M 288 49 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c3b87e1a5e_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 307 8.652344 L 368 8.652344 L 368 77 L 307 77 Z M 307 8.652344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "36200c9188_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 304 8.652344 L 371 8.652344 L 371 49 L 304 49 Z M 304 8.652344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f7583f535c_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 290 55 L 385 55 L 385 118.214844 L 290 118.214844 Z M 290 55 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2487d0a224_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 281 110 L 394.152344 110 L 394.152344 118 L 281 118 Z M 281 110 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6c517a42f5_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 280.863281 110 L 394.152344 110 L 394.152344 118 L 280.863281 118 Z M 280.863281 110 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a3e4422574_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 581.949219 0 L 682.566406 0 L 682.566406 118.503906 L 581.949219 118.503906 Z M 581.949219 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "782e0b70d5_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 51 22 L 101.566406 22 L 101.566406 82 L 51 82 Z M 51 22 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7f7e0f7606_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.285156 3 L 81 3 L 81 82 L 1.285156 82 Z M 1.285156 3 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "43584085af_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.285156 44 L 89 44 L 89 118.503906 L 1.285156 118.503906 Z M 1.285156 44 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "75dd46504a_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 51 22 L 101.566406 22 L 101.566406 74 L 51 74 Z M 51 22 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5f438040f2_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.285156 72 L 30 72 L 30 118 L 1.285156 118 Z M 1.285156 72 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3dd09cd1c5_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.285156 66 L 36 66 L 36 118.503906 L 1.285156 118.503906 Z M 1.285156 66 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3de8c6c61a_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.285156 62 L 33 62 L 33 92 L 1.285156 92 Z M 1.285156 62 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "17f07b2b78_b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 102,
    y: 0,
    height: 119
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7e6b25796f_b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c1ff72",
    d: "M 100.472656 56.6875 C 100.472656 58.289062 100.394531 59.886719 100.238281 61.480469 C 100.082031 63.074219 99.847656 64.65625 99.535156 66.230469 C 99.222656 67.800781 98.832031 69.351562 98.367188 70.886719 C 97.902344 72.417969 97.363281 73.925781 96.75 75.40625 C 96.136719 76.886719 95.453125 78.332031 94.699219 79.746094 C 93.945312 81.15625 93.121094 82.53125 92.230469 83.863281 C 91.339844 85.195312 90.386719 86.480469 89.371094 87.71875 C 88.355469 88.957031 87.28125 90.140625 86.148438 91.273438 C 85.015625 92.40625 83.828125 93.480469 82.589844 94.5 C 81.351562 95.515625 80.066406 96.46875 78.734375 97.359375 C 77.402344 98.246094 76.03125 99.070312 74.617188 99.824219 C 73.203125 100.582031 71.757812 101.265625 70.277344 101.878906 C 68.796875 102.492188 67.292969 103.03125 65.757812 103.496094 C 64.226562 103.960938 62.671875 104.347656 61.101562 104.660156 C 59.53125 104.972656 57.949219 105.210938 56.351562 105.367188 C 54.757812 105.523438 53.160156 105.601562 51.558594 105.601562 C 49.957031 105.601562 48.359375 105.523438 46.765625 105.367188 C 45.171875 105.210938 43.585938 104.972656 42.015625 104.660156 C 40.445312 104.347656 38.890625 103.960938 37.359375 103.496094 C 35.828125 103.03125 34.320312 102.492188 32.839844 101.878906 C 31.359375 101.265625 29.914062 100.582031 28.5 99.824219 C 27.085938 99.070312 25.714844 98.246094 24.382812 97.359375 C 23.050781 96.46875 21.765625 95.515625 20.527344 94.5 C 19.289062 93.480469 18.101562 92.40625 16.96875 91.273438 C 15.835938 90.140625 14.761719 88.957031 13.746094 87.71875 C 12.730469 86.480469 11.777344 85.195312 10.886719 83.863281 C 9.996094 82.53125 9.175781 81.15625 8.417969 79.746094 C 7.664062 78.332031 6.980469 76.886719 6.367188 75.40625 C 5.753906 73.925781 5.214844 72.417969 4.75 70.886719 C 4.285156 69.351562 3.894531 67.800781 3.582031 66.230469 C 3.269531 64.65625 3.035156 63.074219 2.878906 61.480469 C 2.722656 59.886719 2.644531 58.289062 2.644531 56.6875 C 2.644531 55.082031 2.722656 53.484375 2.878906 51.890625 C 3.035156 50.296875 3.269531 48.714844 3.582031 47.144531 C 3.894531 45.570312 4.285156 44.019531 4.75 42.488281 C 5.214844 40.953125 5.753906 39.445312 6.367188 37.964844 C 6.980469 36.488281 7.664062 35.039062 8.417969 33.628906 C 9.175781 32.214844 9.996094 30.84375 10.886719 29.511719 C 11.777344 28.179688 12.730469 26.894531 13.746094 25.652344 C 14.761719 24.414062 15.835938 23.230469 16.96875 22.097656 C 18.101562 20.964844 19.289062 19.890625 20.527344 18.875 C 21.765625 17.855469 23.050781 16.902344 24.382812 16.015625 C 25.714844 15.125 27.085938 14.300781 28.5 13.546875 C 29.914062 12.789062 31.359375 12.105469 32.839844 11.492188 C 34.320312 10.878906 35.828125 10.339844 37.359375 9.875 C 38.890625 9.410156 40.445312 9.023438 42.015625 8.710938 C 43.585938 8.398438 45.171875 8.164062 46.765625 8.003906 C 48.359375 7.847656 49.957031 7.769531 51.558594 7.769531 C 53.160156 7.769531 54.757812 7.847656 56.351562 8.003906 C 57.949219 8.164062 59.53125 8.398438 61.101562 8.710938 C 62.671875 9.023438 64.226562 9.410156 65.757812 9.875 C 67.292969 10.339844 68.796875 10.878906 70.277344 11.492188 C 71.757812 12.105469 73.203125 12.789062 74.617188 13.546875 C 76.03125 14.300781 77.402344 15.125 78.734375 16.015625 C 80.066406 16.902344 81.351562 17.855469 82.589844 18.875 C 83.828125 19.890625 85.015625 20.964844 86.148438 22.097656 C 87.28125 23.230469 88.355469 24.414062 89.371094 25.652344 C 90.386719 26.894531 91.339844 28.179688 92.230469 29.511719 C 93.121094 30.84375 93.945312 32.214844 94.699219 33.628906 C 95.453125 35.039062 96.136719 36.488281 96.75 37.964844 C 97.363281 39.445312 97.902344 40.953125 98.367188 42.488281 C 98.832031 44.019531 99.222656 45.570312 99.535156 47.144531 C 99.847656 48.714844 100.082031 50.296875 100.238281 51.890625 C 100.394531 53.484375 100.472656 55.082031 100.472656 56.6875 Z M 100.472656 56.6875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 43.52999 28.380746 C 43.52999 28.380746 43.910095 28.548989 43.949559 29.899088 L 40.730094 31.010322 C 40.730094 31.010322 37.710028 26.609002 38.200218 25.46038 C 38.690407 24.309681 39.899264 24.700171 40.730094 24.7791 C 41.560924 24.860106 43.52999 28.380746 43.52999 28.380746 Z M 43.52999 28.380746 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#59557b5dae_b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 6.328125 139.921875 C 6.628906 126.628906 10.054688 66.765625 47.554688 66.652344 C 47.554688 66.652344 51.371094 70.019531 56.316406 66.539062 C 56.316406 66.539062 64.214844 67.96875 75.59375 73.914062 C 74.859375 70.207031 74.464844 67.746094 74.464844 67.746094 L 75.933594 67.238281 L 79.222656 66.109375 L 80.671875 65.601562 L 85.277344 64 L 88.023438 63.0625 C 88.023438 63.0625 96.5625 79.742188 98.726562 89.710938 C 100.871094 99.675781 101 108.6875 90.789062 107.480469 C 90.582031 107.445312 90.394531 107.40625 90.167969 107.351562 C 90.054688 107.332031 89.941406 107.292969 89.847656 107.257812 C 83.285156 105.507812 71.90625 97.871094 71.230469 97.757812 C 71.230469 97.757812 71.8125 115.511719 74.464844 122.847656 C 77.058594 130.011719 80.21875 134.996094 76.175781 139.921875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2c99078a3b_b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 1.959425 70.269104 C 2.11936 63.20082 3.940954 31.369656 23.880867 31.309421 C 23.880867 31.309421 25.910169 33.099859 28.539745 31.249186 C 28.539745 31.249186 32.739589 32.009395 38.790107 35.170702 C 38.399617 33.199559 38.189832 31.891002 38.189832 31.891002 L 38.970812 31.620982 L 40.719709 31.020708 L 41.490303 30.750688 L 43.939174 29.899088 L 45.399357 29.40059 C 45.399357 29.40059 49.939842 38.269697 51.090541 43.570391 C 52.230854 48.869007 52.299398 53.660818 46.869926 53.019002 C 46.759841 53.000308 46.660141 52.979537 46.539671 52.950458 C 46.479436 52.940073 46.419201 52.919302 46.369351 52.900608 C 42.879866 51.970079 36.829349 47.909399 36.470015 47.849164 C 36.470015 47.849164 36.779499 57.289466 38.189832 61.190212 C 39.56901 64.999566 41.249363 67.649913 39.099591 70.269104 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#04321c",
    d: "M 69.085938 65.109375 C 63.800781 67.988281 63.011719 63.304688 63.011719 63.304688 C 63.011719 63.304688 60.078125 67.105469 51.558594 66.03125 C 43.039062 67.105469 40.105469 63.304688 40.105469 63.304688 C 40.105469 63.304688 39.316406 67.988281 34.03125 65.109375 C 28.746094 62.214844 26.828125 45.648438 30.628906 29.8125 C 34.445312 13.957031 51.558594 14.917969 51.558594 14.917969 C 51.558594 14.917969 68.691406 13.957031 72.492188 29.8125 C 76.289062 45.648438 74.371094 62.214844 69.085938 65.109375 Z M 69.085938 65.109375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9ee8a7f53e_b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 35.329701 30.488977 C 32.519419 32.019781 32.09985 29.529369 32.09985 29.529369 C 32.09985 29.529369 30.539968 31.550362 26.009869 30.979166 C 21.47977 31.550362 19.919887 29.529369 19.919887 29.529369 C 19.919887 29.529369 19.500318 32.019781 16.690036 30.488977 C 13.879755 28.949865 12.859911 20.140993 14.880905 11.720534 C 16.910206 3.289689 26.009869 3.800649 26.009869 3.800649 C 26.009869 3.800649 35.119916 3.289689 37.14091 11.720534 C 39.159826 20.140993 38.139982 28.949865 35.329701 30.488977 Z M 35.329701 30.488977 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 33.470719 23.080053 C 32.59004 25.759479 31.069622 28.019336 28.55013 28.999715 L 28.55013 31.249186 C 28.55013 31.249186 29.410039 34.109317 27.929085 36.259089 C 27.119026 37.440944 25.380515 37.430559 24.599535 36.219625 C 23.849711 35.060617 23.199587 33.330414 23.889176 31.309421 L 23.889176 29.369434 C 20.570011 28.74008 18.690259 26.199818 17.649645 23.080053 C 14.45095 23.659557 13.150702 20.280157 14.480029 19.110764 C 15.279703 18.400404 16.139612 18.500104 16.739886 18.720274 C 16.530102 16.990071 16.480252 15.259868 16.509331 13.720756 C 16.559181 10.690305 18.929122 8.270513 21.810024 8.270513 L 29.320725 8.270513 C 32.19955 8.270513 34.569492 10.690305 34.619342 13.720756 C 34.650498 15.249483 34.600648 16.9693 34.399172 18.699503 C 34.989061 18.489719 35.840661 18.41079 36.619564 19.110764 C 37.950969 20.280157 36.65072 23.649171 33.470719 23.080053 Z M 33.470719 23.080053 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 19.699717 17.9206 C 19.699717 17.9206 20.530547 16.740822 22.890103 17.420025 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#04321c",
    d: "M 44 44.613281 C 44 44.765625 43.96875 44.910156 43.910156 45.050781 C 43.851562 45.191406 43.769531 45.316406 43.664062 45.421875 C 43.554688 45.53125 43.429688 45.613281 43.289062 45.671875 C 43.148438 45.730469 43.003906 45.757812 42.851562 45.757812 C 42.699219 45.757812 42.554688 45.730469 42.414062 45.671875 C 42.273438 45.613281 42.148438 45.53125 42.039062 45.421875 C 41.933594 45.316406 41.851562 45.191406 41.792969 45.050781 C 41.734375 44.910156 41.703125 44.765625 41.703125 44.613281 C 41.703125 44.460938 41.734375 44.3125 41.792969 44.171875 C 41.851562 44.03125 41.933594 43.910156 42.039062 43.800781 C 42.148438 43.695312 42.273438 43.609375 42.414062 43.550781 C 42.554688 43.492188 42.699219 43.464844 42.851562 43.464844 C 43.003906 43.464844 43.148438 43.492188 43.289062 43.550781 C 43.429688 43.609375 43.554688 43.695312 43.664062 43.800781 C 43.769531 43.910156 43.851562 44.03125 43.910156 44.171875 C 43.96875 44.3125 44 44.460938 44 44.613281 Z M 44 44.613281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 31.389491 17.829209 C 31.389491 17.829209 30.458962 16.499881 27.819 17.270476 ",
    stroke: "#000000",
    strokeWidth: 0.336,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#04321c",
    d: "M 56.882812 44.800781 C 56.882812 45.515625 57.445312 46.078125 58.160156 46.078125 C 58.875 46.078125 59.4375 45.515625 59.4375 44.800781 C 59.4375 44.085938 58.875 43.519531 58.160156 43.519531 C 57.445312 43.519531 56.882812 44.105469 56.882812 44.800781 Z M 56.882812 44.800781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 25.669228 19.330934 L 25.179039 21.310386 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 25.54045 21.530555 C 25.54045 21.530555 24.580841 20.890817 24.159195 21.22938 C 23.729241 21.57002 24.690926 22.490164 24.690926 22.490164 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fillOpacity: 1,
    fill: "#04321c",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 18.060905 12.289652 C 18.060905 12.289652 21.120436 15.509117 23.290978 15.099933 C 25.459444 14.69075 23.860097 12.509822 23.860097 12.509822 C 23.860097 12.509822 26.539523 14.30026 29.48066 14.460195 C 32.41972 14.620129 33.719968 17.519725 33.759433 18.900979 C 33.759433 18.900979 36.659029 18.36094 35.389936 11.209573 C 34.120844 4.060284 25.459444 4.280453 22.050965 5.109206 C 18.640409 5.940036 16.050297 8.330748 15.919442 12.200338 C 15.790663 16.059542 15.570493 17.210241 16.239311 17.30994 C 16.910206 17.399255 17.93005 14.240025 18.060905 12.289652 Z M 18.060905 12.289652 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 40.64078 28.200041 C 40.499539 28.389055 40.229519 28.440982 40.040505 28.299741 L 33.630654 23.699021 L 34.139537 22.999047 L 40.549389 27.599766 C 40.740479 27.741008 40.779944 28.011027 40.64078 28.200041 Z M 40.64078 28.200041 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 33.269243 22.629328 L 32.999224 22.999047 C 32.81021 23.260758 32.870445 23.620092 33.130079 23.809106 C 33.389714 24.000197 33.749047 23.939962 33.940138 23.680327 L 34.210158 23.300223 C 34.399172 23.040588 34.341014 22.679177 34.079302 22.490164 C 33.809283 22.309458 33.449949 22.369693 33.269243 22.629328 Z M 33.269243 22.629328 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 32.519419 17.280861 C 30.660438 15.939071 28.070326 16.369026 26.730613 18.230084 C 25.399209 20.089066 25.829163 22.679177 27.690222 24.010582 C 29.549203 25.350295 32.131007 24.920341 33.470719 23.059282 C 34.800047 21.200301 34.380478 18.610189 32.519419 17.280861 Z M 32.870445 22.629328 C 31.769596 24.160131 29.640594 24.50908 28.109791 23.410308 C 26.578987 22.319844 26.230038 20.190842 27.330888 18.660039 C 28.42966 17.129235 30.560738 16.780287 32.089465 17.870751 C 33.620269 18.969523 33.969217 21.100601 32.870445 22.629328 Z M 32.870445 22.629328 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 38.970812 31.620982 C 38.970812 31.620982 35.209231 28.139806 35.389936 26.359753 C 35.560256 24.569315 37.219839 23.300223 37.770263 23.809106 C 38.320688 24.320066 37.180374 26.260054 37.180374 26.260054 C 37.180374 26.260054 40.580545 27.030648 41.490303 30.758996 Z M 38.970812 31.620982 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 39.19929 23.530778 C 39.19929 23.530778 38.580322 24.5797 38.009127 25.090661 C 37.450394 25.599544 38.079747 26.380524 38.970812 26.010805 C 39.8598 25.639008 40.809023 24.45923 41.029193 24.160131 C 41.249363 23.850647 40.329219 22.110059 39.19929 23.530778 Z M 39.19929 23.530778 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 40.430995 24.610857 C 40.430995 24.610857 39.80995 25.659779 39.240832 26.170739 C 38.669636 26.679623 39.309375 27.460603 40.20044 27.090883 C 41.089428 26.719087 42.040728 25.539309 42.260898 25.24021 C 42.478991 24.939034 41.560924 23.200523 40.430995 24.610857 Z M 40.430995 24.610857 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 41.660623 25.699244 C 41.660623 25.699244 41.039578 26.750243 40.47046 27.259126 C 39.899264 27.770087 40.539003 28.548989 41.430068 28.17927 C 42.319056 27.809551 43.270356 26.629773 43.490526 26.330674 C 43.710696 26.029498 42.790552 24.280602 41.660623 25.699244 Z M 41.660623 25.699244 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 42.599461 27.279897 C 42.599461 27.279897 41.990878 27.859401 41.519382 28.100341 C 41.049964 28.339205 41.330369 28.970636 41.990878 28.88963 C 42.649311 28.810701 43.500911 28.200041 43.70031 28.040106 C 43.899709 27.880172 43.610996 26.550844 42.599461 27.279897 Z M 42.599461 27.279897 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e57eb24b4c_b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 23.761719 139.921875 C 23.292969 102.234375 32.320312 79.441406 32.320312 79.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0a32614c7d_b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 11.229408 70.269104 C 10.980159 50.229491 15.780278 38.109762 15.780278 38.109762 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 23.909946 24.230752 C 23.909946 24.230752 26.200959 24.230752 27.590522 24.230752 C 27.590522 24.230752 27.249882 26.289133 25.771005 26.289133 C 24.350286 26.289133 23.909946 24.230752 23.909946 24.230752 Z M 23.909946 24.230752 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.88065, 0, 0, 1.88065, 2.643131, 7.770277)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 36.4804 47.849164 L 34.249622 43.360606 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#c1ff72",
    d: "M 386.441406 63.535156 C 386.441406 65.136719 386.363281 66.730469 386.207031 68.324219 C 386.050781 69.917969 385.816406 71.496094 385.503906 73.066406 C 385.191406 74.636719 384.804688 76.183594 384.339844 77.714844 C 383.875 79.246094 383.335938 80.75 382.722656 82.230469 C 382.113281 83.707031 381.429688 85.152344 380.675781 86.5625 C 379.921875 87.972656 379.097656 89.34375 378.210938 90.671875 C 377.320312 92.003906 376.371094 93.285156 375.355469 94.523438 C 374.339844 95.761719 373.265625 96.945312 372.136719 98.074219 C 371.003906 99.207031 369.820312 100.28125 368.582031 101.292969 C 367.347656 102.308594 366.0625 103.261719 364.734375 104.148438 C 363.402344 105.039062 362.03125 105.859375 360.621094 106.613281 C 359.210938 107.367188 357.765625 108.050781 356.289062 108.664062 C 354.8125 109.277344 353.304688 109.8125 351.777344 110.277344 C 350.246094 110.742188 348.695312 111.132812 347.125 111.441406 C 345.558594 111.753906 343.976562 111.988281 342.382812 112.148438 C 340.792969 112.304688 339.195312 112.382812 337.597656 112.382812 C 335.996094 112.382812 334.402344 112.304688 332.808594 112.148438 C 331.21875 111.988281 329.636719 111.753906 328.066406 111.441406 C 326.5 111.132812 324.949219 110.742188 323.417969 110.277344 C 321.886719 109.8125 320.382812 109.277344 318.90625 108.664062 C 317.425781 108.050781 315.980469 107.367188 314.570312 106.613281 C 313.160156 105.859375 311.789062 105.039062 310.460938 104.148438 C 309.128906 103.261719 307.847656 102.308594 306.609375 101.292969 C 305.375 100.28125 304.1875 99.207031 303.058594 98.074219 C 301.925781 96.945312 300.855469 95.761719 299.839844 94.523438 C 298.824219 93.285156 297.871094 92.003906 296.984375 90.671875 C 296.09375 89.34375 295.273438 87.972656 294.519531 86.5625 C 293.765625 85.152344 293.082031 83.707031 292.46875 82.230469 C 291.859375 80.75 291.320312 79.246094 290.855469 77.714844 C 290.390625 76.183594 290.003906 74.636719 289.691406 73.066406 C 289.378906 71.496094 289.144531 69.917969 288.988281 68.324219 C 288.832031 66.730469 288.75 65.136719 288.75 63.535156 C 288.75 61.9375 288.832031 60.339844 288.988281 58.75 C 289.144531 57.15625 289.378906 55.578125 289.691406 54.007812 C 290.003906 52.4375 290.390625 50.886719 290.855469 49.359375 C 291.320312 47.828125 291.859375 46.324219 292.46875 44.84375 C 293.082031 43.367188 293.765625 41.921875 294.519531 40.511719 C 295.273438 39.101562 296.09375 37.730469 296.984375 36.398438 C 297.871094 35.070312 298.824219 33.785156 299.839844 32.550781 C 300.855469 31.3125 301.925781 30.128906 303.058594 28.996094 C 304.1875 27.867188 305.375 26.792969 306.609375 25.777344 C 307.847656 24.765625 309.128906 23.8125 310.460938 22.921875 C 311.789062 22.035156 313.160156 21.214844 314.570312 20.460938 C 315.980469 19.703125 317.425781 19.023438 318.90625 18.410156 C 320.382812 17.796875 321.886719 17.257812 323.417969 16.792969 C 324.949219 16.332031 326.5 15.941406 328.066406 15.628906 C 329.636719 15.316406 331.21875 15.082031 332.808594 14.925781 C 334.402344 14.769531 335.996094 14.691406 337.597656 14.691406 C 339.195312 14.691406 340.792969 14.769531 342.382812 14.925781 C 343.976562 15.082031 345.558594 15.316406 347.125 15.628906 C 348.695312 15.941406 350.246094 16.332031 351.777344 16.792969 C 353.304688 17.257812 354.8125 17.796875 356.289062 18.410156 C 357.765625 19.023438 359.210938 19.703125 360.621094 20.460938 C 362.03125 21.214844 363.402344 22.035156 364.734375 22.921875 C 366.0625 23.8125 367.347656 24.765625 368.582031 25.777344 C 369.820312 26.792969 371.003906 27.867188 372.136719 28.996094 C 373.265625 30.128906 374.339844 31.3125 375.355469 32.550781 C 376.371094 33.785156 377.320312 35.070312 378.210938 36.398438 C 379.097656 37.730469 379.921875 39.101562 380.675781 40.511719 C 381.429688 41.921875 382.113281 43.367188 382.722656 44.84375 C 383.335938 46.324219 383.875 47.828125 384.339844 49.359375 C 384.804688 50.886719 385.191406 52.4375 385.503906 54.007812 C 385.816406 55.578125 386.050781 57.15625 386.207031 58.75 C 386.363281 60.339844 386.441406 61.9375 386.441406 63.535156 Z M 386.441406 63.535156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.877934, 0, 0, 1.877934, 280.864382, 9.207992)",
    fillOpacity: 1,
    fill: "#04321c",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 40.619178 17.010366 C 40.619178 17.010366 39.920272 20.140884 43.109031 22.749302 C 46.299871 25.3598 45.280633 30.599516 39.730985 33.029048 C 34.179256 35.460659 18.089852 35.200649 18.02953 28.049341 C 17.969208 20.900112 20.839716 21.540777 20.519384 17.010366 Z M 40.619178 17.010366 ",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 378.199219 110.671875 L 296.734375 110.671875 C 296.734375 110.671875 299.605469 90.070312 306.328125 76.871094 C 313.035156 63.6875 333.128906 57.621094 333.128906 57.621094 L 341.804688 57.621094 C 341.804688 57.621094 361.898438 63.6875 368.601562 76.871094 C 375.324219 90.070312 378.199219 110.671875 378.199219 110.671875 Z M 378.199219 110.671875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#04e445921d_b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.877934, 0, 0, 1.877934, 280.864382, 9.207992)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 51.830799 54.029516 L 8.450771 54.029516 C 8.450771 54.029516 9.979628 43.059184 13.559442 36.0306 C 17.130936 29.010337 27.830858 25.779976 27.830858 25.779976 L 32.450711 25.779976 C 32.450711 25.779976 43.150633 29.010337 46.720047 36.0306 C 50.299861 43.059184 51.830799 54.029516 51.830799 54.029516 Z M 51.830799 54.029516 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 352.339844 43.628906 C 350.535156 49.078125 347.363281 53.601562 341.878906 55.140625 L 341.878906 57.488281 C 341.878906 57.488281 343.492188 62.878906 340.714844 66.898438 C 339.191406 69.113281 335.925781 69.09375 334.480469 66.824219 C 333.050781 64.644531 331.832031 61.394531 333.128906 57.621094 L 333.128906 55.160156 C 327.644531 53.621094 324.453125 49.09375 322.628906 43.628906 C 316.621094 44.71875 314.179688 38.371094 316.675781 36.175781 C 318.179688 34.839844 319.792969 35.03125 320.921875 35.441406 C 320.527344 32.195312 320.433594 28.945312 320.488281 26.054688 C 320.582031 20.363281 325.035156 15.816406 330.441406 15.816406 L 344.546875 15.816406 C 349.953125 15.816406 354.40625 20.363281 354.5 26.054688 C 354.554688 28.925781 354.460938 32.15625 354.085938 35.40625 C 355.191406 35.011719 356.789062 34.859375 358.253906 36.175781 C 360.75 38.371094 358.308594 44.699219 352.339844 43.628906 Z M 352.339844 43.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c3b87e1a5e_b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.877934, 0, 0, 1.877934, 280.864382, 9.207992)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 38.060682 18.329136 C 37.099686 21.230845 35.410662 23.639575 32.490233 24.459126 L 32.490233 25.709253 C 32.490233 25.709253 33.349305 28.579761 31.87037 30.720161 C 31.059139 31.899565 29.320194 31.889165 28.550565 30.680639 C 27.789256 29.519956 27.140272 27.789331 27.830858 25.779976 L 27.830858 24.469526 C 24.910428 23.649976 23.211005 21.239165 22.239608 18.329136 C 19.040448 18.909478 17.740399 15.529351 19.069569 14.360347 C 19.870399 13.64896 20.729471 13.750884 21.330614 13.969292 C 21.120526 12.240748 21.070604 10.510123 21.099725 8.970865 C 21.149647 5.940191 23.520936 3.51898 26.399764 3.51898 L 33.910926 3.51898 C 36.789754 3.51898 39.161043 5.940191 39.210965 8.970865 C 39.240086 10.499722 39.190164 12.219947 38.990477 13.950572 C 39.579139 13.740484 40.429891 13.659361 41.20992 14.360347 C 42.53909 15.529351 41.239041 18.899077 38.060682 18.329136 Z M 38.060682 18.329136 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#04321c",
    d: "M 324.1875 27.125 C 324.1875 27.125 330.5 31.273438 333.746094 30.316406 C 336.976562 29.359375 334.628906 25.527344 334.628906 25.527344 C 334.628906 25.527344 338.179688 30.523438 344.414062 29.566406 C 350.648438 28.605469 351.925781 29.28125 352.808594 30.917969 C 353.691406 32.550781 354.105469 35.386719 354.105469 35.386719 C 354.105469 35.386719 355.644531 34.070312 357.144531 35.066406 C 357.144531 35.066406 360.261719 9.265625 337.484375 9.675781 C 314.027344 10.109375 317.710938 27.949219 317.917969 35.386719 C 317.917969 35.386719 320.058594 34.691406 320.921875 35.425781 C 320.921875 35.425781 323.230469 33.828125 324.1875 27.125 Z M 324.1875 27.125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#36200c9188_b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.877934, 0, 0, 1.877934, 280.864382, 9.207992)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 23.069559 9.540806 C 23.069559 9.540806 26.430965 11.749849 28.15951 11.24023 C 29.879735 10.730611 28.629608 8.690054 28.629608 8.690054 C 28.629608 8.690054 30.520399 11.350474 33.840203 10.840855 C 37.160008 10.329156 37.840194 10.689009 38.310291 11.560562 C 38.780389 12.430035 39.000877 13.940171 39.000877 13.940171 C 39.000877 13.940171 39.820428 13.239185 40.619178 13.769605 C 40.619178 13.769605 42.27908 0.0306893 30.150145 0.249098 C 17.659276 0.479986 19.62079 9.979703 19.731034 13.940171 C 19.731034 13.940171 20.870917 13.569917 21.330614 13.960972 C 21.330614 13.960972 22.55994 13.11022 23.069559 9.540806 Z M 23.069559 9.540806 ",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.877934, 0, 0, 1.877934, 280.864382, 9.207992)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 24.240643 13.270386 C 24.240643 13.270386 25.070594 12.090982 27.429403 12.769087 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#04321c",
    d: "M 330.6875 37.246094 C 330.6875 37.398438 330.65625 37.542969 330.597656 37.683594 C 330.539062 37.824219 330.457031 37.949219 330.351562 38.054688 C 330.242188 38.164062 330.121094 38.246094 329.980469 38.304688 C 329.839844 38.363281 329.691406 38.390625 329.539062 38.390625 C 329.386719 38.390625 329.242188 38.363281 329.101562 38.304688 C 328.960938 38.246094 328.835938 38.164062 328.730469 38.054688 C 328.621094 37.949219 328.539062 37.824219 328.480469 37.683594 C 328.425781 37.542969 328.394531 37.398438 328.394531 37.246094 C 328.394531 37.09375 328.425781 36.949219 328.480469 36.808594 C 328.539062 36.667969 328.621094 36.542969 328.730469 36.433594 C 328.835938 36.328125 328.960938 36.246094 329.101562 36.1875 C 329.242188 36.128906 329.386719 36.101562 329.539062 36.101562 C 329.691406 36.101562 329.839844 36.128906 329.980469 36.1875 C 330.121094 36.246094 330.242188 36.328125 330.351562 36.433594 C 330.457031 36.542969 330.539062 36.667969 330.597656 36.808594 C 330.65625 36.949219 330.6875 37.09375 330.6875 37.246094 Z M 330.6875 37.246094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.877934, 0, 0, 1.877934, 280.864382, 9.207992)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 35.930682 13.180943 C 35.930682 13.180943 35.000887 11.849693 32.359188 12.619322 ",
    stroke: "#000000",
    strokeWidth: 0.336,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#04321c",
    d: "M 343.550781 37.453125 C 343.550781 38.164062 344.113281 38.730469 344.828125 38.730469 C 345.539062 38.730469 346.105469 38.164062 346.105469 37.453125 C 346.105469 36.738281 345.539062 36.175781 344.828125 36.175781 C 344.113281 36.175781 343.550781 36.757812 343.550781 37.453125 Z M 343.550781 37.453125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.877934, 0, 0, 1.877934, 280.864382, 9.207992)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 30.210467 14.680679 L 29.719569 16.660913 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.877934, 0, 0, 1.877934, 280.864382, 9.207992)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 30.079422 16.871001 C 30.079422 16.871001 29.120506 16.230337 28.700331 16.56939 C 28.269754 16.910523 29.230751 17.829917 29.230751 17.829917 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.877934, 0, 0, 1.877934, 280.864382, 9.207992)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 28.450721 19.579263 C 28.450721 19.579263 30.740887 19.579263 32.130379 19.579263 C 32.130379 19.579263 31.789247 21.64062 30.310311 21.64062 C 28.889618 21.64062 28.450721 19.579263 28.450721 19.579263 Z M 28.450721 19.579263 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.877934, 0, 0, 1.877934, 280.864382, 9.207992)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 38.950955 17.089409 C 38.950955 17.089409 39.219285 14.990611 40.369568 15.040533 ",
    stroke: "#000000",
    strokeWidth: 0.336,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.877934, 0, 0, 1.877934, 280.864382, 9.207992)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 19.920321 15.319263 C 19.920321 15.319263 21.160048 15.100855 21.580223 17.089409 ",
    stroke: "#000000",
    strokeWidth: 0.336,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.877934, 0, 0, 1.877934, 280.864382, 9.207992)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 19.550067 36.070122 C 19.550067 36.070122 16.508993 45.249506 16.760683 54.019115 ",
    stroke: "#000000",
    strokeWidth: 0.336,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.877934, 0, 0, 1.877934, 280.864382, 9.207992)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 40.369568 36.070122 C 40.369568 36.070122 43.240076 46.360268 42.730457 54.019115 ",
    stroke: "#000000",
    strokeWidth: 0.336,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#04321c",
    d: "M 371.285156 68.53125 L 367.925781 110.257812 L 307.550781 110.257812 L 304.1875 68.53125 Z M 371.285156 68.53125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f7583f535c_b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.877934, 0, 0, 1.877934, 280.864382, 9.207992)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 48.14906 31.589634 L 46.360193 53.809027 L 14.210507 53.809027 L 12.41956 31.589634 Z M 48.14906 31.589634 ",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2487d0a224_b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 281.144531 110.671875 L 394.066406 110.671875 L 394.066406 117.394531 L 281.144531 117.394531 Z M 281.144531 110.671875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6c517a42f5_b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.877934, 0, 0, 1.877934, 280.864382, 9.207992)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.149179 54.029516 L 60.280076 54.029516 L 60.280076 57.60933 L 0.149179 57.60933 Z M 0.149179 54.029516 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a3e4422574_b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 581, -0.00000000000000155)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#17f07b2b78_b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c1ff72",
    d: "M 8.113281 40.917969 C 8.113281 42.261719 8.179688 43.597656 8.3125 44.929688 C 8.445312 46.265625 8.640625 47.589844 8.902344 48.902344 C 9.164062 50.21875 9.488281 51.515625 9.878906 52.796875 C 10.265625 54.082031 10.71875 55.339844 11.230469 56.578125 C 11.742188 57.816406 12.316406 59.027344 12.945312 60.210938 C 13.578125 61.390625 14.265625 62.539062 15.011719 63.652344 C 15.757812 64.769531 16.554688 65.84375 17.402344 66.878906 C 18.253906 67.914062 19.152344 68.90625 20.101562 69.855469 C 21.046875 70.800781 22.039062 71.699219 23.074219 72.550781 C 24.113281 73.402344 25.1875 74.199219 26.300781 74.941406 C 27.414062 75.6875 28.5625 76.375 29.746094 77.007812 C 30.925781 77.640625 32.136719 78.210938 33.375 78.722656 C 34.613281 79.238281 35.875 79.6875 37.15625 80.078125 C 38.4375 80.464844 39.738281 80.792969 41.050781 81.054688 C 42.367188 81.316406 43.691406 81.511719 45.023438 81.640625 C 46.359375 81.773438 47.695312 81.839844 49.035156 81.839844 C 50.375 81.839844 51.710938 81.773438 53.046875 81.640625 C 54.378906 81.511719 55.703125 81.316406 57.019531 81.054688 C 58.332031 80.792969 59.628906 80.464844 60.914062 80.078125 C 62.195312 79.6875 63.457031 79.238281 64.695312 78.722656 C 65.933594 78.210938 67.140625 77.640625 68.324219 77.007812 C 69.507812 76.375 70.652344 75.6875 71.769531 74.941406 C 72.882812 74.199219 73.957031 73.402344 74.992188 72.550781 C 76.03125 71.699219 77.023438 70.800781 77.96875 69.855469 C 78.917969 68.90625 79.816406 67.914062 80.667969 66.878906 C 81.515625 65.84375 82.3125 64.769531 83.058594 63.652344 C 83.804688 62.539062 84.492188 61.390625 85.121094 60.210938 C 85.753906 59.027344 86.328125 57.816406 86.839844 56.578125 C 87.351562 55.339844 87.804688 54.082031 88.191406 52.796875 C 88.582031 51.515625 88.90625 50.21875 89.167969 48.902344 C 89.429688 47.589844 89.625 46.265625 89.757812 44.929688 C 89.890625 43.597656 89.953125 42.261719 89.953125 40.917969 C 89.953125 39.578125 89.890625 38.242188 89.757812 36.910156 C 89.625 35.574219 89.429688 34.25 89.167969 32.9375 C 88.90625 31.621094 88.582031 30.324219 88.191406 29.042969 C 87.804688 27.757812 87.351562 26.5 86.839844 25.261719 C 86.328125 24.023438 85.753906 22.8125 85.121094 21.628906 C 84.492188 20.449219 83.804688 19.300781 83.058594 18.1875 C 82.3125 17.070312 81.515625 15.996094 80.667969 14.960938 C 79.816406 13.925781 78.917969 12.933594 77.96875 11.984375 C 77.023438 11.039062 76.03125 10.136719 74.992188 9.289062 C 73.957031 8.4375 72.882812 7.640625 71.769531 6.894531 C 70.652344 6.152344 69.507812 5.464844 68.324219 4.832031 C 67.140625 4.199219 65.933594 3.628906 64.695312 3.113281 C 63.457031 2.601562 62.195312 2.152344 60.914062 1.761719 C 59.628906 1.371094 58.332031 1.046875 57.019531 0.785156 C 55.703125 0.523438 54.378906 0.328125 53.046875 0.195312 C 51.710938 0.0664062 50.375 0 49.035156 0 C 47.695312 0 46.359375 0.0664062 45.023438 0.195312 C 43.691406 0.328125 42.367188 0.523438 41.050781 0.785156 C 39.738281 1.046875 38.4375 1.371094 37.15625 1.761719 C 35.875 2.152344 34.613281 2.601562 33.375 3.113281 C 32.136719 3.628906 30.925781 4.199219 29.746094 4.832031 C 28.5625 5.464844 27.414062 6.152344 26.300781 6.894531 C 25.1875 7.640625 24.113281 8.4375 23.074219 9.289062 C 22.039062 10.136719 21.046875 11.039062 20.101562 11.984375 C 19.152344 12.933594 18.253906 13.925781 17.402344 14.960938 C 16.554688 15.996094 15.757812 17.070312 15.011719 18.1875 C 14.265625 19.300781 13.578125 20.449219 12.945312 21.628906 C 12.316406 22.8125 11.742188 24.023438 11.230469 25.261719 C 10.71875 26.5 10.265625 27.757812 9.878906 29.042969 C 9.488281 30.324219 9.164062 31.621094 8.902344 32.9375 C 8.640625 34.25 8.445312 35.574219 8.3125 36.910156 C 8.179688 38.242188 8.113281 39.578125 8.113281 40.917969 Z M 8.113281 40.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 58.332031 30.238281 C 58.160156 30.710938 67.160156 32.1875 68.433594 33.777344 C 69.707031 35.351562 73.386719 39.457031 78.5625 39.566406 L 85.597656 61.371094 L 79.980469 60.945312 L 78.171875 73.5 C 78.171875 73.5 96.042969 77.527344 99.457031 67.886719 C 99.597656 67.507812 99.691406 67.113281 99.753906 66.703125 C 101.5 56.636719 84.886719 37.253906 84.886719 37.253906 C 84.886719 37.253906 75.96875 29.355469 68.324219 29.121094 C 65.035156 29.027344 58.519531 29.75 58.332031 30.238281 Z M 58.332031 30.238281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#782e0b70d5_b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-1.573228, 0, 0, 1.573228, 100.117493, 0.00000099375)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 26.560341 19.220537 C 26.669591 19.520975 20.948867 20.459531 20.139425 21.470093 C 19.329982 22.470723 16.99104 25.080306 13.701128 25.149829 L 9.22933 39.009672 L 12.799816 38.73903 L 13.949423 46.71924 C 13.949423 46.71924 2.589914 49.279165 0.419813 43.151237 C 0.330427 42.910391 0.270836 42.659612 0.231109 42.398902 C -0.878771 36.000333 9.681227 23.679921 9.681227 23.679921 C 9.681227 23.679921 15.349809 18.65939 20.208947 18.510413 C 22.299594 18.450822 26.441159 18.910168 26.560341 19.220537 Z M 26.560341 19.220537 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#04321c",
    d: "M 42.679688 14.757812 C 42.679688 14.757812 37.25 13.277344 33.382812 21.648438 C 29.496094 30.015625 31.445312 33.226562 22.996094 36.578125 C 14.566406 39.929688 15.699219 45.75 16.972656 49.226562 C 18.246094 52.703125 18.183594 54.921875 12.285156 56.382812 C 6.398438 57.863281 8.195312 66.296875 16.832031 67.632812 C 25.46875 68.96875 31.886719 65.699219 44.078125 68.84375 C 56.273438 71.992188 68.511719 71.722656 69.1875 64.296875 C 69.863281 56.871094 60.425781 47.292969 61.496094 41.535156 C 62.566406 35.789062 42.679688 14.757812 42.679688 14.757812 Z M 42.679688 14.757812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7f7e0f7606_b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-1.573228, 0, 0, 1.573228, 100.117493, 0.00000099375)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 36.509533 9.380595 C 36.509533 9.380595 39.960837 8.439556 42.418961 13.760524 C 44.889499 19.079009 43.650505 21.119996 49.021132 23.25037 C 54.379345 25.380743 53.659288 29.080343 52.849846 31.290171 C 52.040403 33.499999 52.08013 34.910317 55.829389 35.838941 C 59.571199 36.77998 58.429041 42.140675 52.939232 42.989845 C 47.449423 43.839015 43.369932 41.760784 35.620636 43.759561 C 27.868857 45.760821 20.089766 45.589497 19.660215 40.869403 C 19.230664 36.14931 25.229478 30.06111 24.549149 26.401237 C 23.86882 22.748813 36.509533 9.380595 36.509533 9.380595 Z M 36.509533 9.380595 ",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 25.34375 117.992188 C 25.34375 117.992188 26.457031 87.140625 25.910156 78.171875 C 25.894531 77.8125 25.875 77.496094 25.84375 77.214844 L 19.222656 84.515625 C 19.222656 84.515625 10.882812 80.832031 7.566406 68.984375 C 7.566406 68.984375 14.441406 59.910156 30.597656 54.199219 C 34.199219 52.921875 38.273438 51.804688 42.835938 51.003906 L 46.910156 51.050781 C 46.910156 51.050781 60.425781 52.65625 66.386719 54.199219 C 72.335938 55.722656 81.300781 57.675781 81.300781 57.675781 C 81.300781 57.675781 83.582031 67.851562 78.972656 76.285156 C 78.972656 76.285156 74.082031 76.222656 70.257812 75.34375 C 70.257812 75.34375 73.386719 95.289062 72.304688 117.992188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#43584085af_b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-1.573228, 0, 0, 1.573228, 100.117493, 0.00000099375)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 47.528878 75.000073 C 47.528878 75.000073 46.821236 55.389712 47.16885 49.688852 C 47.178781 49.46042 47.191196 49.259301 47.21106 49.080529 L 51.419665 53.721167 C 51.419665 53.721167 56.720769 51.379743 58.828796 43.848947 C 58.828796 43.848947 54.458799 38.081047 44.189306 34.45097 C 41.900024 33.639045 39.310304 32.92892 36.410215 32.419915 L 33.820495 32.44971 C 33.820495 32.44971 25.229478 33.470204 21.440492 34.45097 C 17.658955 35.419322 11.960578 36.660798 11.960578 36.660798 C 11.960578 36.660798 10.510534 43.128891 13.440418 48.489586 C 13.440418 48.489586 16.549075 48.449859 18.979886 47.891194 C 18.979886 47.891194 16.99104 60.569151 17.678818 75.000073 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-1.573228, 0, 0, 1.573228, 100.117493, 0.00000099375)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 38.950276 25.298806 C 38.639906 26.259709 37.840396 27.640231 36.410215 28.779906 L 36.410215 32.419915 C 36.410215 32.419915 36.509533 37.159872 32.549223 39.009672 C 32.549223 39.009672 30.329463 36.650867 31.630531 32.859398 L 31.700053 30.738956 C 30.490855 30.920211 29.09047 30.91028 27.508829 30.669433 C 20.439862 29.569485 23.118968 14.649421 23.118968 14.649421 C 23.118968 14.649421 23.28036 12.211162 31.429411 11.409168 C 37.510163 10.810776 38.910548 17.499851 39.119116 21.671212 C 39.590877 21.239178 40.271207 20.928809 41.14024 21.321116 C 42.900654 22.110695 41.850365 26.669396 38.950276 25.298806 Z M 38.950276 25.298806 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-1.573228, 0, 0, 1.573228, 100.117493, 0.00000099375)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 32.300928 18.830714 C 32.400246 18.860509 34.269909 18.219907 35.620636 19.719611 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-1.573228, 0, 0, 1.573228, 100.117493, 0.00000099375)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 23.930894 19.220537 C 23.930894 19.220537 24.7602 18.041135 27.119005 18.718981 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04321c",
    d: "M 58.867188 32.863281 C 58.867188 33.128906 58.960938 33.355469 59.148438 33.542969 C 59.335938 33.730469 59.5625 33.824219 59.828125 33.824219 C 60.09375 33.824219 60.316406 33.730469 60.503906 33.542969 C 60.691406 33.355469 60.785156 33.128906 60.785156 32.863281 C 60.785156 32.601562 60.691406 32.375 60.503906 32.1875 C 60.316406 32 60.09375 31.90625 59.828125 31.90625 C 59.5625 31.90625 59.335938 32 59.148438 32.1875 C 58.960938 32.375 58.867188 32.601562 58.867188 32.863281 Z M 58.867188 32.863281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04321c",
    d: "M 47.132812 32.863281 C 47.132812 33.382812 47.554688 33.824219 48.089844 33.824219 C 48.625 33.824219 49.050781 33.398438 49.050781 32.863281 C 49.050781 32.328125 48.625 31.90625 48.089844 31.90625 C 47.554688 31.90625 47.132812 32.328125 47.132812 32.863281 Z M 47.132812 32.863281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-1.573228, 0, 0, 1.573228, 100.117493, 0.00000099375)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 29.338765 21.040542 L 28.849623 23.009524 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-1.573228, 0, 0, 1.573228, 100.117493, 0.00000099375)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 29.19972 23.230506 C 29.19972 23.230506 28.238817 22.589904 27.819198 22.930069 C 27.389647 23.270234 28.35055 24.188926 28.35055 24.188926 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-1.573228, 0, 0, 1.573228, 100.117493, 0.00000099375)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 27.709948 26.609805 C 27.709948 26.609805 29.659066 27.468907 31.858962 25.998999 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-1.573228, 0, 0, 1.573228, 100.117493, 0.00000099375)",
    fillOpacity: 1,
    fill: "#04321c",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 39.069457 20.869218 C 39.069457 20.869218 34.85092 18.358953 34.719324 15.890898 C 34.719324 15.890898 30.038958 16.869181 26.930301 13.760524 C 26.930301 13.760524 26.729182 17.110028 22.639758 19.669952 C 22.639758 19.669952 19.868783 17.080232 22.930264 11.841202 C 25.999193 6.619552 34.679597 7.808886 36.509533 9.380595 C 36.509533 9.380595 39.039662 8.869107 40.50957 11.7394 C 41.979478 14.609694 40.50957 21.149792 40.50957 21.149792 L 39.129048 21.671212 Z M 39.069457 20.869218 ",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-1.573228, 0, 0, 1.573228, 100.117493, 0.00000099375)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 47.21106 49.09046 C 47.21106 49.09046 45.021095 44.750259 44.849772 41.259227 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 99.753906 66.703125 C 101.5 56.636719 84.886719 37.253906 84.886719 37.253906 C 84.886719 37.253906 75.96875 29.355469 68.324219 29.121094 C 65.035156 29.027344 58.519531 29.75 58.332031 30.238281 C 58.160156 30.710938 67.160156 32.1875 68.433594 33.777344 C 69.707031 35.351562 73.386719 39.457031 78.5625 39.566406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#75dd46504a_b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-1.573228, 0, 0, 1.573228, 100.117493, 0.00000099375)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.231109 42.398902 C -0.878771 36.000333 9.681227 23.679921 9.681227 23.679921 C 9.681227 23.679921 15.349809 18.65939 20.208947 18.510413 C 22.299594 18.450822 26.441159 18.910168 26.560341 19.220537 C 26.669591 19.520975 20.948867 20.459531 20.139425 21.470093 C 19.329982 22.470723 16.99104 25.080306 13.701128 25.149829 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5f438040f2_b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 19.648438 82.042969 L 16.296875 86.195312 L 29.226562 117.992188 L 19.550781 117.992188 C 19.550781 117.992188 1.445312 93.953125 1.445312 84.984375 C 1.445312 84.984375 4.71875 78.046875 8.855469 72.683594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3dd09cd1c5_b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-1.573228, 0, 0, 1.573228, 100.117493, 0.00000099375)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 51.149023 52.149458 L 53.279397 54.788837 L 45.060823 75.000073 L 51.211097 75.000073 C 51.211097 75.000073 62.719583 59.719982 62.719583 54.019122 C 62.719583 54.019122 60.638869 49.609398 58.009422 46.200303 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 7.566406 68.984375 C 10.882812 80.832031 19.222656 84.515625 19.222656 84.515625 L 25.84375 77.214844 C 25.875 77.496094 25.894531 77.8125 25.910156 78.171875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3de8c6c61a_b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-1.573228, 0, 0, 1.573228, 100.117493, 0.00000099375)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 58.828796 43.848947 C 56.720769 51.379743 51.419665 53.721167 51.419665 53.721167 L 47.21106 49.080529 C 47.191196 49.259301 47.178781 49.46042 47.16885 49.688852 ",
    stroke: "#000000",
    strokeWidth: 0.3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2StandingPerson);
export default __webpack_public_path__ + "static/media/icon2-standing-person.a36b882c4459f3604c36a832a783a92c.svg";
export { ForwardRef as ReactComponent };